import qs from 'qs';
import { checkText } from 'smile2emoji';

import { translate } from 'services/i18nService';
import createMessagingService from 'services/MessagingService/MessagingService';
import NotificationService from 'services/NotificationService';
import {
  PRIVATE_SHOW_REQUEST_SENT,
  PRIVATE_SHOW_STOP_PS,
  PRIVATE_SHOW_STOP_SPY,
  REQUEST_PLAY_TOKEN,
} from 'services/MessagingService/EventNames';
import FirebaseStore from 'stores/FirebaseStore';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import APIStates from 'enum/APIStates';
import allUserGroups from 'enum/userGroups';
import ApiService from 'services/ApiService/ApiService';
import { generateQueryFromObject } from 'utils/helpers';

import {
  PRIVATE_SHOW_ACTION_URL,
  WEBCHAT_POST_MESSAGE_MAIN_CHAT,
  WEBCHAT_POST_MESSAGE_PRIVATE_CHAT,
} from './Api';


const MessagingService = createMessagingService();

const handleRequestPlayTokenReponse = (response) => {
  let WebRTCOutput = response?.data?.outputs?.find?.((output) => output.protocol === 'WebRTC');
  if (response?.data?.output?.protocol === 'WebRTC') {
    const { data: { output } } = response;
    const { streamingProvider } = FirebaseStore;
    output.provider = streamingProvider;
    WebRTCOutput = output;
  }

  const cam2CamCf = UserStore.hasCF(allUserGroups.CAM2CAM_VIEWER);
  const jinkCf = UserStore.hasCF(allUserGroups.JINK_PLAYER);
  const jinkUser = jinkCf || cam2CamCf;

  const isCam2Cam = FirebaseStore?.newShowsDetails?.cam2cam;

  if (jinkUser && isCam2Cam && WebRTCOutput) {
    UserStore.setWebRTCSource(WebRTCOutput);
  }

  const hlsResponse = response?.data?.hls;
  if (hlsResponse) {
    ProfileStore.setPrivateHls(hlsResponse);
  }

  const playToken = response?.data?.playToken;
  if (playToken) {
    ProfileStore.setPlayToken(playToken);
  }

  MessagingService.emit(REQUEST_PLAY_TOKEN, response.data);
};

// API CALLS
export function setPrivateShowAction(json) {
  const URL = ApiService.substitute(PRIVATE_SHOW_ACTION_URL, { username: json.username });
  ProfileStore.setSpyRequestInProgress(true);
  ProfileStore.setPsGsLoading(APIStates.PENDING);

  return ApiService.post(URL, {
    data: qs.stringify(json),
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
  })
    .then((response) => {
      if (json.action === 'request' && !json.extend) {
        MessagingService.emit(PRIVATE_SHOW_REQUEST_SENT);
      }

      if (json.action === 'cancelRequest' || json.action === 'request') {
        if (json.extend) {
          NotificationService.create({
            type: NotificationService.type.TOAST,
            text: translate('v2profile.private.show.extended'),
            subtype: NotificationService.subtype.SUCCESS,
          });
        }
      } else if (json.action === 'requestPlayToken' || json.action === 'startSpy') {
        handleRequestPlayTokenReponse(response);
      }
      if (json.action === 'stopPS') {
        FirebaseStore.cancelStatePrivateShow(APIStates.LOADED);
        MessagingService.emit(PRIVATE_SHOW_STOP_PS, response.data);
      }
      if (json.action === 'stopSpy') {
        FirebaseStore.cancelStatePrivateShow(APIStates.LOADED);
        MessagingService.emit(PRIVATE_SHOW_STOP_SPY, response.data);
      }
    })
    .catch((err) => {
      /* eslint-disable-next-line */
      console.warn(err);
    })
    .finally(() => {
      ProfileStore.setSpyRequestInProgress(false);
      FirebaseStore.setPrivateShowLoadingButtonState(APIStates.LOADED);
    });
}

export function sendMainChatMessage(username, accessHash, roomname, message) {
  const messageData = {
    username,
    accessHash,
    roomname,
    message: checkText(message),
  };

  const parsedURL = encodeURI(`${WEBCHAT_POST_MESSAGE_MAIN_CHAT}${generateQueryFromObject(messageData)}`);

  return ApiService.post(parsedURL)
    .then((res) => res)
    .catch((error) => {
      /* eslint-disable-next-line */
      console.error(error);
    });
}

export function sendPrivateChatMessage(username, recipient, accessHash, roomname, message) {
  const messageData = {
    username,
    accessHash,
    recipient,
    roomname,
    message: checkText(message),
  };
  const parsedURL = encodeURI(`${WEBCHAT_POST_MESSAGE_PRIVATE_CHAT}${generateQueryFromObject(messageData)}`);

  return ApiService.post(parsedURL)
    .then((res) => res)
    .catch((error) => {
      /* eslint-disable-next-line */
      console.error(error);
    });
}
